const invertedMessages = {
  Activate: 'Auth.Label.ActivateButton',
  Back: 'Auth.Label.BackButton',
  Cancel: 'Auth.Label.CancelButton',
  Confirm: 'Auth.Label.ConfirmButton',
  Deactivate: 'Auth.Label.DeactivateButton',
  Delete: 'Auth.Label.DeleteButton',
  Edit: 'Auth.Label.EditButton',
  'Enable Test Mode': 'Auth.Label.EnableTestModeButton',
  Options: 'Auth.Label.OverflowOptionsButton',
  Save: 'Auth.Label.SaveButton',
  Select: 'Auth.Label.SelectAnSSOProviderButton',
  'Select {ssoProvider}': 'Auth.Label.SelectSSOProviderButton.A11yLabel',
  Load: 'Auth.Label.LoadButton',
  'Add Provider': 'Auth.Label.AddProviderButton',
  'SP Meta Data': 'Auth.Label.SPMetaDataButton',
  'Copy Login URL': 'Auth.Label.CopyLoginURLButton',
  'Copied! To test, open in incognito window':
    'Auth.Label.CopiedLoginURLConfirmation',
  'Display Name': 'Auth.Label.SSODisplayNameInput',
  Alias: 'Auth.Label.SSOAliasInput',
  'Redirect URL': 'Auth.Label.SSORedirectURLInput',
  'SP Entity ID': 'Auth.Label.SSOSPEntityIDInput',
  'Want Assertions Signed': 'Auth.Label.SSOWantAssertionsSignedToggle',
  'Want Assertions Encrypted': 'Auth.Label.SSOWantAssertionsEncryptedToggle',
  'Force Authentication': 'Auth.Label.SSOForceAuthenticationToggle',
  'Validate Signatures': 'Auth.Label.SSOValidateSignaturesToggle',
  'Sign Service Provider Metadata': 'Auth.Label.SSOSignSPMetadataToggle',
  'Single Logout Service URL': 'Auth.Label.SSOLogoutServiceURLInput',
  'Enable Single Logout (SLO)': 'Auth.Label.SSOEnableSingleLogoutToggle',
  'Enable federated logout between Saviynt and the external Identity Provider.':
    'Auth.Label.SSOEnableSingleLogoutHelperText',
  'Single Logout has been disabled. To enable it, upload new IdP metadata that includes a Single Logout URL.':
    'Auth.Label.SSOSingleLogoutUnavailableMessage',
  'Want Authn Requests Signed': 'Auth.Label.SSOWantAuthnRequestsSignedToggle',
  'NameID Policy Format': 'Auth.Label.SSONameIDPolicyFormatInput',
  'Use Entity Descriptor':
    'Auth.Label.SSOMetadataFilePicker.UseEntityDescriptorToggle',
  'Entity Descriptor URL':
    'Auth.Label.SSOMetadataFilePicker.EntityDescriptorURLInput',
  'via URL': 'Auth.Label.MetadataFilePicker.urlChoice',
  'via File Upload': 'Auth.Label.MetadataFilePicker.fileChoice',
  'How would you like to configure the entity descriptor?':
    'Auth.Label.MetadataFilePicker.samlEntityDescriptorPrompt',
  'Upload File': 'Auth.Label.uploadFile',
  Copied: 'Auth.Label.copied',
  'Copy to Clipboard': 'Auth.Label.copyToClipboard',
  'Multi-IdP Lookup': 'Auth.Label.SSOMultiIdpLookup',
  'Saviynt Username': 'Auth.Label.SSOSaviyntUsername',
  'N/A': 'Auth.Label.NotApplicable',
  Email: 'Auth.Label.Email',
  Username: 'Auth.Label.Username',
  'System Username': 'Auth.Label.SystemUsername',
  Providers: 'Auth.Label.ProvidersTab',
  Settings: 'Auth.Label.SettingsTab',
  Keys: 'Auth.Label.KeysTab',
  'Add Key': 'Auth.Label.AddKeyButton',
  Download: 'Auth.Label.DownloadButton',
  Remove: 'Auth.Label.RemoveButton',
  'Default Key': 'Auth.Label.DefaultKey',
  'Key Name': 'Auth.Label.KeyNameInput',
  'Private Key': 'Auth.Label.PrivateKeyInput',
  Certificate: 'Auth.Label.CertificateInput',
  'Terminate logins and remove key': 'Auth.Label.TerminateLoginsAndRemoveKey',
  'Name ID Format': 'Auth.Label.SSONameIdFormatDropdown',
  EmailAddress: 'Auth.Label.NameIdFormat.EmailAddress',
  Transient: 'Auth.Label.NameIdFormat.Transient',
  Persistent: 'Auth.Label.NameIdFormat.Persistent',
  x509SubjectName: 'Auth.Label.NameIdFormat.X509SubjectName',
  Unspecified: 'Auth.Label.NameIdFormat.Unspecified',
  'Principal Type': 'Auth.Label.SSOPrincipalType',
  Attribute: 'Auth.Label.PrincipalType.Attribute',
  'Friendly Attribute': 'Auth.Label.PrincipalType.FriendlyAttribute',
  'Principal Attribute': 'Auth.Label.SSOPrincipalAttribute',

  // Custom Property keys should use `Customproperty${i}.Default.label` for translations
  'Custom Property 1': 'Customproperty1.Default.label',
  'Custom Property 2': 'Customproperty2.Default.label',
  'Custom Property 3': 'Customproperty3.Default.label',
  'Custom Property 4': 'Customproperty4.Default.label',
  'Custom Property 5': 'Customproperty5.Default.label',
  'Custom Property 6': 'Customproperty6.Default.label',
  'Custom Property 7': 'Customproperty7.Default.label',
  'Custom Property 8': 'Customproperty8.Default.label',
  'Custom Property 9': 'Customproperty9.Default.label',
  'Custom Property 10': 'Customproperty10.Default.label',
  'Custom Property 11': 'Customproperty11.Default.label',
  'Custom Property 12': 'Customproperty12.Default.label',
  'Custom Property 13': 'Customproperty13.Default.label',
  'Custom Property 14': 'Customproperty14.Default.label',
  'Custom Property 15': 'Customproperty15.Default.label',
  'Custom Property 16': 'Customproperty16.Default.label',
  'Custom Property 17': 'Customproperty17.Default.label',
  'Custom Property 18': 'Customproperty18.Default.label',
  'Custom Property 19': 'Customproperty19.Default.label',
  'Custom Property 20': 'Customproperty20.Default.label',
  'Custom Property 21': 'Customproperty21.Default.label',
  'Custom Property 22': 'Customproperty22.Default.label',
  'Custom Property 23': 'Customproperty23.Default.label',
  'Custom Property 24': 'Customproperty24.Default.label',
  'Custom Property 25': 'Customproperty25.Default.label',
  'Custom Property 26': 'Customproperty26.Default.label',
  'Custom Property 27': 'Customproperty27.Default.label',
  'Custom Property 28': 'Customproperty28.Default.label',
  'Custom Property 29': 'Customproperty29.Default.label',
  'Custom Property 30': 'Customproperty30.Default.label',
  'Custom Property 31': 'Customproperty31.Default.label',
  'Custom Property 32': 'Customproperty32.Default.label',
  'Custom Property 33': 'Customproperty33.Default.label',
  'Custom Property 34': 'Customproperty34.Default.label',
  'Custom Property 35': 'Customproperty35.Default.label',
  'Custom Property 36': 'Customproperty36.Default.label',
  'Custom Property 37': 'Customproperty37.Default.label',
  'Custom Property 38': 'Customproperty38.Default.label',
  'Custom Property 39': 'Customproperty39.Default.label',
  'Custom Property 40': 'Customproperty40.Default.label',
  'Custom Property 41': 'Customproperty41.Default.label',
  'Custom Property 42': 'Customproperty42.Default.label',
  'Custom Property 43': 'Customproperty43.Default.label',
  'Custom Property 44': 'Customproperty44.Default.label',
  'Custom Property 45': 'Customproperty45.Default.label',
  'Custom Property 46': 'Customproperty46.Default.label',
  'Custom Property 47': 'Customproperty47.Default.label',
  'Custom Property 48': 'Customproperty48.Default.label',
  'Custom Property 49': 'Customproperty49.Default.label',
  'Custom Property 50': 'Customproperty50.Default.label',
  'Custom Property 51': 'Customproperty51.Default.label',
  'Custom Property 52': 'Customproperty52.Default.label',
  'Custom Property 53': 'Customproperty53.Default.label',
  'Custom Property 54': 'Customproperty54.Default.label',
  'Custom Property 55': 'Customproperty55.Default.label',
  'Custom Property 56': 'Customproperty56.Default.label',
  'Custom Property 57': 'Customproperty57.Default.label',
  'Custom Property 58': 'Customproperty58.Default.label',
  'Custom Property 59': 'Customproperty59.Default.label',
  'Custom Property 60': 'Customproperty60.Default.label',
  'Custom Property 61': 'Customproperty61.Default.label',
  'Custom Property 62': 'Customproperty62.Default.label',
  'Custom Property 63': 'Customproperty63.Default.label',
  'Custom Property 64': 'Customproperty64.Default.label',
  'Custom Property 65': 'Customproperty65.Default.label',

  // Client Credentials
  'Client Name': 'Auth.Label.ClientName',
  'Roles (comma-separated)': 'Auth.Label.RolesCommaSeparated',
  'Custom Claims (JSON)': 'Auth.Label.CustomClaimsJSON',
  'Key Source': 'Auth.Label.KeySource',
  'Public Certificate': 'Auth.Label.PublicCertificate',
  'Public Certificate (.pem)': 'Auth.Label.PublicCertificatePem',
  'JWKS URL': 'Auth.Label.JwksUrl',
  'Create Client': 'Auth.Label.CreateClientButton',
  'Save Changes': 'Auth.Label.SaveChangesButton',
  Enabled: 'Auth.Label.Enabled',
  Disabled: 'Auth.Label.Disabled',
  Enable: 'Auth.Label.EnableButton',
  Disable: 'Auth.Label.DisableButton',
  'Enable/Disable': 'Auth.Label.EnableDisableButton',
  'Client limit reached': 'Auth.Label.ClientLimitReached',
  'Unable to load roles. Please try again later.':
    'Auth.Label.RolesLoadErrorTooltip',
  'Unable to load roles. Create is disabled until roles are available.':
    'Auth.Label.RolesLoadErrorBanner',
  'Client Name A-Z': 'Auth.Label.SortClientNameAsc',
  'Client Name Z-A': 'Auth.Label.SortClientNameDesc',
  'Status: Enabled first': 'Auth.Label.SortEnabledFirst',
  'Status: Disabled first': 'Auth.Label.SortDisabledFirst',
  Roles: 'Auth.Label.Roles',
  'Custom Claims': 'Auth.Label.CustomClaims',
  Status: 'Auth.Label.Status',
  Description: 'Auth.Label.Description',
  'Client ID': 'Auth.Label.ClientId',
  'Roles:': 'Auth.Label.RolesColon',
  'Custom Claims:': 'Auth.Label.CustomClaimsColon',
  'Assigned roles': 'Auth.Label.AssignedRoles',
  'Custom claims': 'Auth.Label.CustomClaimsSection',
  Done: 'Auth.Label.DoneButton',
  'This action is irreversible.': 'Auth.Label.IrreversibleAction',
  'The client and all associated credentials will be permanently deleted.':
    'Auth.Label.ClientDeleteWarning',
  'To confirm, type the client name': 'Auth.Label.TypeClientNameToConfirm',
  'below:': 'Auth.Label.Below',
  Client: 'Auth.Label.Client',
  'Are you sure you want to enable this client?':
    'Auth.Label.EnableClientWarning',
  'Are you sure you want to disable this client? Existing integrations may fail.':
    'Auth.Label.DisableClientWarning',
  'Delete Client…': 'Auth.Label.DeleteClient',
  more: 'Auth.Label.More',
  '{count, plural, one {# claim} other {# claims}}': 'Auth.Label.ClaimsCount',
  '{count} more roles': 'Auth.Label.MoreRolesA11y',
  'Add Client Credential': 'Auth.Label.AddClientCredentialButton',
  'Edit {name}': 'Auth.Label.EditClientA11y',
  'More actions for {name}': 'Auth.Label.MoreActionsA11y',
  'Search all providers': 'Auth.Label.SearchAllProviders',
  'Client created successfully': 'Auth.Label.ClientCreatedSuccessTitle',
  'Your new client credential has been created and is ready to use.':
    'Auth.Label.ClientCreatedSuccessSubtitle',
  'Your new client has been successfully registered. You can now use the credentials below to authenticate and manage your integrations.':
    'Auth.Label.ClientCreatedSuccessSubtitleFull',
  '{claimKey}: {claimValue}': 'Auth.Label.ClaimKeyValue',
  'This action is irreversible. The client and all associated credentials will be permanently deleted.':
    'Auth.Label.ClientDeleteWarningFull',
  Create: 'Auth.Label.CreateButton',
  Submit: 'Auth.Label.SubmitButton',
  'A static, manually uploaded file containing a public key, requiring manual updates whenever the certificate expires or rotates.':
    'Auth.Label.PublicCertificateDescription',
  'A web endpoint that allows your system to automatically fetch and rotate public keys without manual intervention.':
    'Auth.Label.JwksUrlDescription',
  'Rotate Certificate': 'Auth.Label.RotateCertificateButton',
  Rotate: 'Auth.Label.RotateButton',
  'Public Certificate (.pem, .crt)': 'Auth.Label.PublicCertificatePemCrt',
  Audience: 'Auth.Label.Audience',
};

export default invertedMessages;
